export const routes_names = {
  invitation: 'invitation',
  accept_ownership: 'accept-ownership',
  conference: 'conference',
  forget_password: 'forget-password',
  dashboard: 'dashboard',
  signup: 'signup',
  login: 'login',
}